import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrmHeaderComponent } from './hrm-header.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HrmHeaderComponent],
  exports: [HrmHeaderComponent]
})
export class HrmHeaderComponentModule {}
